module.exports = __webpack_public_path__ + "humans.txt";